import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { INotificationState } from "./hooks"
import { resetStoreAction } from "config"
import notificationAPI from "./notificationAPI"

export const checkIsUserHasLogThreeMeal = createAsyncThunk(
  "notification/checkIsUserHasLogThreeMeal",
  async (_, { rejectWithValue }) => {
    try {
      const isHasLoggedThreeMeals =
        await notificationAPI.checkIsUserHasLogThreeMeal()
      return isHasLoggedThreeMeals
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

const initialState: INotificationState = {
  snackbarInfos: [],
  shouldShowFitBanner: false,
  isTurnedOffShowFitBanner: false,

  checkIsUserHasLogThreeMealFailed: null,
  foodInFitVersion: "v1",
  isAppOutDated: false,

  customSnackbarInfo: undefined,
}

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    notifyAppOutdate(state) {
      state.isAppOutDated = true
    },

    turnOffShowFitBanner(state) {
      state.shouldShowFitBanner = false
      state.isTurnedOffShowFitBanner = true
    },

    showSnackbar(state, { payload }) {
      state.snackbarInfos.unshift(payload)
    },

    hideSnackbar(state, { payload: id }) {
      const snackbar = state.snackbarInfos.find(
        (snackbar) => snackbar.id === id,
      )
      if (snackbar) {
        snackbar.status = "inactive"
      }
    },

    showCustomSnackbar(state, { payload }) {
      state.customSnackbarInfo = payload
    },

    hideCustomSnackbar(state) {
      if (state.customSnackbarInfo) {
        state.customSnackbarInfo.status = "inactive"
      }
    },

    setFoodInFitVersion(state, { payload: version }) {
      state.foodInFitVersion = version
    },

    removeSnackbar(state, { payload: id }) {
      state.snackbarInfos = state.snackbarInfos.filter(
        (snackbar) => snackbar.id !== id,
      )
    },
  },

  extraReducers(builder) {
    builder
      .addCase(checkIsUserHasLogThreeMeal.pending, (state) => {
        state.checkIsUserHasLogThreeMealFailed = null
      })
      .addCase(checkIsUserHasLogThreeMeal.fulfilled, (state, { payload }) => {
        state.shouldShowFitBanner = payload
      })
      .addCase(checkIsUserHasLogThreeMeal.rejected, (state, { payload }) => {
        state.checkIsUserHasLogThreeMealFailed = payload
      })

      .addCase(resetStoreAction, () => {
        return initialState
      })
  },
})

export const {
  showSnackbar,
  hideSnackbar,
  removeSnackbar,
  turnOffShowFitBanner,
  setFoodInFitVersion,
  notifyAppOutdate,
  showCustomSnackbar,
  hideCustomSnackbar,
} = notificationSlice.actions

export default notificationSlice.reducer
